import { createSelector } from '@reduxjs/toolkit';
import { DefaultRootState } from 'react-redux';
import { BackupState } from '../../reducers/backups';

export const getClaudeActionsSelector = createSelector((state: DefaultRootState) => state.backups, ({claude}: BackupState) => claude.actions);
export const getClaudeActionsTotalSelector = createSelector((state: DefaultRootState) => state.backups, ({claude}: BackupState) => claude.totalActions);
export const isClaudeActionsLoadingSelector = createSelector((state: DefaultRootState) => state.backups, ({claude}: BackupState) => claude.loading);
export const getClaudeCanRestore = createSelector((state: DefaultRootState) => state.backups, ({claude}: BackupState) => claude.canRestore);
